<template>
	<div>
		<el-dialog :visible.sync="iswin" title="选择寄递方式" width="650px" :close-on-click-modal="false" lock-scroll :modal-append-to-body="false" :show-close="false">
			<div class="sendtype">
				<table class="htmltable">
					<tr>
						<td colspan="5" class="tips">
							此步骤非必填，后期可搜索
							<span v-if="pkval != ''">订单号 {{ pkval }}</span>
							<span v-if="p_batch != ''">批次号 {{ p_batch }}</span>
							来进行设置
						</td>
					</tr>
					<tr>
						<td><label>寄件类型</label></td>
						<td colspan="4">
							<el-select ref="sendtype" v-model="sendtype" placeholder="请选择" size="mini" @change="changesendtype">
								<el-option v-for="item in sendoption" :key="item.d_value" :label="item.d_name" :value="item.d_value"></el-option>
							</el-select>
							<input type="hidden" v-model="sendtypename" ref="sendtypename" />
						</td>
					</tr>
					<tr v-if="sendtype == '1'">
						<td><label>门店地址</label></td>
						<td colspan="4">
							<div class="address">{{ s_address }}</div>
						</td>
					</tr>
					<tr v-if="sendtype == '2'">
						<td><label>联系人</label></td>
						<td><el-input type="text" size="mini" v-model="sendername" ref="sendername"></el-input></td>
						<td style="width:40px"></td>
						<td><label>联系电话</label></td>
						<td><el-input type="text" size="mini" v-model="senderphone" ref="senderphone"></el-input></td>
					</tr>
					<tr v-if="sendtype == '2'">
						<td><label>取件地址</label></td>
						<td colspan="4"><el-input type="textarea" size="mini" v-model="senderaddress" ref="senderaddress"></el-input></td>
					</tr>
					<tr v-if="sendtype == '2'">
						<td><label>指定取件时间</label></td>
						<td><el-date-picker v-model="packtime" type="datetime" placeholder="选择取件时间" size="mini" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker></td>
						<!-- <td style="width:40px"></td>
						<td><label>来前电话</label></td>
						<td><el-switch v-model="iscall"></el-switch></td> -->
					</tr>
					<tr v-if="sendtype == '3'">
						<td><label>快递单号</label></td>
						<td><el-input type="text" size="mini" v-model="expressid_gn" ref="expressid_gn"></el-input></td>
						<td style="width:40px"></td>
						<td><label>快递公司</label></td>
						<td>
							<el-select v-model="expresscode_gn" filterable placeholder="请选择" size="mini" ref="expresscode_gn" @change="changeexpresscom">
								<el-option v-for="item in expresscom" :key="item.d_value" :label="item.d_name" :value="item.d_value"></el-option>
							</el-select>
							<input type="hidden" v-model="expresscom_gn" ref="expresscom_gn" />
						</td>
					</tr>
					<tr v-if="issave == 1">
						<td colspan="5" style="text-align:center;">
							<el-button @click="cancelsendtype(false)" :size="btnsize">取消</el-button>
							<el-button type="success" @click="savesendtype" :size="btnsize" style="margin-left:10px">保存</el-button>
						</td>
					</tr>
				</table>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	props: {
		// s_address: {
		// 	//门店地址
		// 	type: String,
		// 	default: ''
		// },
		issave: {
			type: String,
			default: '0'
		},
		batch: {
			type: String,
			default: ''
		},
		p_batch: {
			type: String,
			default: ''
		},
		// pkval: {
		// 	type: String,
		// 	default: ''
		// },
		// iswin: {
		// 	type: String,
		// 	default: '0'
		// },
		mode: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			iswin:false,
			sendoption: [],
			sendtype: '',
			sendtypename: '',
			sendername: '',
			senderphone: '',
			senderaddress: '',
			expressid_gn: '',
			expresscom_gn: '',
			expresscode_gn: '',
			expresscom: [],
			btnsize: 'mini',
			iscall: false,
			packtime: '',
			s_address:'',
			pkval:''
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			//console.log('主题描述', res);
			import('../../static/' + res + '/style/sendtype.scss');
		});
	},
	methods: {
		//初始化
		init(param) {
			if(param.batch!=undefined)
				this.batch = param.batch; //临时表批次号
			if(param.p_batch!=undefined)
				this.p_batch = param.p_batch; //临时表批次号
			if (param.pkval != undefined) {
				this.pkval = param.pkval;
			}
			if (param.iswin != undefined&&param.iswin=='1') {
				this.iswin=true;
				this.btnsize = 'mini';
			}else{
				this.btnsize = '';
				this.iswin=false;
			}
			this.getdic();
		},
		GetShop(){
			var that=this;
			this.$apipost.get.GetShopByUser().then(res => {
				if(res.info!=''){
					var address=res.info.name+' '+res.info.phone+' '+res.info.province+' '+res.info.city+' '+res.info.district+' '+res.info.street+res.info.detailaddr+'  '+res.info.postcode+' '+res.info.country;
					that.s_address=address;
				}
			});
		},
		getdic() {
			var that = this;
			this.$apipost.get.dic({ type: '寄件类型' }).then(res => {
				if (res != '') {
					that.sendoption = res.list;
					if (res.list.length > 0) {
						that.sendtype = res.list[0].d_value;
						that.sendtypename = res.list[0].d_name;
						if(that.sendtype!='2'){
							that.GetShop();
						}
					}
				}
			});
			this.$apipost.get.dic({ type: '快递公司' }).then(res => {
				if (res != '') {
					that.expresscom = res.list;
				}
			});
		},
		changesendtype(value) {
			var that = this;
			this.sendoption.forEach(e => {
				if (e.d_value == value) {
					that.sendtypename = e.d_name;
					return false;
				}
			});
		},
		changeexpresscom(value) {
			var that = this;
			this.expresscom.forEach(e => {
				if (e.d_value == value) {
					that.expresscom_gn = e.d_name;
					return false;
				}
			});
		},
		//保存寄件类型
		savesendtype() {
			var that = this;
			if (this.batch != '' || this.p_batch != '' || this.pkval != '') {
				var sendinfo = new Object();
				sendinfo.sendtypename = this.sendtypename;
				sendinfo.sendername = this.sendername;
				sendinfo.senderphone = this.senderphone;
				sendinfo.senderaddress = this.senderaddress;
				sendinfo.expressid_gn = this.expressid_gn;
				sendinfo.expresscom_gn = this.expresscom_gn;
				sendinfo.expresscode_gn = this.expresscode_gn;
				sendinfo.packtime = this.$tool.formatdate(this.packtime);
				sendinfo.iscall = this.iscall;
				sendinfo.sendtype=this.sendtype;
				if (this.sendtypename == '') {
					this.$tool.message('请选择寄件类型', 0);
					return false;
				}
				if (this.sendtype == '2') {
					if (sendinfo.sendername == '') {
						this.$tool.message('请填写联系人', 0);
						return false;
					}
					if (sendinfo.senderphone == '') {
						this.$tool.message('请填写联系电话', 0);
						return false;
					}
					if (sendinfo.sendaddress == '') {
						this.$tool.message('请填写取件地址', 0);
						return false;
					}
				}
				if (this.sendtype == '3') {
					if (sendinfo.expressid_gn == '') {
						this.$tool.message('请填写快递单号', 0);
						return false;
					}
					if (sendinfo.expresscom_gn == '') {
						this.$tool.message('请选择快递公司', 0);
						return false;
					}
				}
				this.$tool.loading('正在保存','sendtype');
				//console.log(JSON.stringify(sendinfo));
				this.$apipost.post.SetSendType({ sendertype: JSON.stringify(sendinfo), 
				batch: this.batch, 
				pkval: this.pkval, 
				p_batch: this.p_batch }).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						if (res.state == '1') {
							if (that.iswin == '1') {
								this.$tool.message(res.message, 1);
								setTimeout(function() {
									that.cancelsendtype(false);
								},200);
							} else {
								if (that.p_batch != undefined && that.p_batch != '') {
									this.$tool.message('导入成功', 1);
								} else if (that.pkval != undefined && that.pkval != '') {
									this.$tool.message('保存成功', 1);
								}
								//关闭当前选项卡
								setTimeout(function() {
									Utils.$emit('handleRermove', that.mode);
								}, 1500);
							}
						} else {
							this.$tool.message(res.message, 0);
						}
					}
				});
			}
		},
		//取消设置寄件类型
		cancelsendtype(iswin) {
			this.iswin=false;
			if (iswin) {
				Utils.$emit('handleRermove', localStorage.getItem('tabname'));
			} else {
				Utils.$emit('sendtypehandle', {
					winname: 'sendtypewin',
					funname: 'cancel'
				});
				if(this.$parent.showwin!=undefined)
					this.$parent.showwin=true;
			}

		}
	}
};
</script>
